import React from 'react';
import styled from 'styled-components';
import colors from '../../../../tailwind.colors';
import { cnMerge, convertMarkdownToHtml } from '../../../utils/utils';

const StyledDiv = styled.div`
  a {
    color: ${colors.primary[500]};
    transition: opacity 300ms ease-in;
    opacity: 1;
    cursor: pointer;
    text-decoration: underline;

    &:hover {
      opacity: 0.6;
    }
  }

  p,
  h2,
  h3,
  h4,
  table {
    margin: 0 0 15px;
  }

  h2 {
    font-size: 1.75rem;
    font-weight: 700;
  }

  h3 {
    font-size: clamp(1rem, 1.45rem, 2rem);
    font-weight: 700;
  }

  h4 {
    font-weight: 700;
  }

  ul,
  ol {
    margin: 0 0 15px 20px;
  }
  ol {
    counter-reset: item;
  }
  ol li {
    list-style-type: none; // decimal;
    counter-increment: item;
    position: relative;
  }
  ol li:before {
    content: counter(item) '.';
    position: absolute;
    left: -16px;
    font-weight: 700;
    display: inline-block;
    text-align: center;
  }

  ul li {
    list-style-type: disc;
  }

  li {
    margin: 0 0 8px;

    ul,
    ol {
      margin-left: 20px;
    }
  }

  table {
    thead {
      height: 40px;
      border-bottom: 1px solid ${colors.customGray[300]};

      tr > td {
        padding: 10px 20px;
      }
    }

    tbody {
      tr > td {
        padding: 10px 20px;
        border-bottom: 1px solid ${colors.customGray[300]};
      }
    }
  }
`;

export const StyledHtmlDiv = ({ content, className }) => (
  <StyledDiv
    className={cnMerge(className, 'text-clamp-md !text-customGray-900')}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);

export const StyledHtmlMobileDiv = ({ content, className }) => (
  <StyledDiv
    className={cnMerge(
      className,
      ' lg:hidden sm:inline max-md:h-52 !text-customGray-900'
    )}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);
